function EssentialStar() {
  return (
    <p
      style={{
        display: "inline",
        color: "red",
      }}
    >
      *
    </p>
  );
}

export default EssentialStar;
